import { render, staticRenderFns } from "./press_edit.vue?vue&type=template&id=6b98cb1c&"
import script from "./press_edit.vue?vue&type=script&lang=js&"
export * from "./press_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports